<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'coupon',
    data(){
        return{

        }
    }
}
</script> 
<style scope lang="scss">
    
</style>